import { render, staticRenderFns } from "./selectClass.vue?vue&type=template&id=2efbc77c&scoped=true&"
import script from "./selectClass.vue?vue&type=script&lang=js&"
export * from "./selectClass.vue?vue&type=script&lang=js&"
import style0 from "./selectClass.vue?vue&type=style&index=0&id=2efbc77c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbc77c",
  null
  
)

export default component.exports